export enum enumBacAccountStatus {
  Allocated= 1,
  Open,
  Suspended,
  Closed,
  Limited,
  Dormant,
  'Not Applicable',
  'Semi Dormant',
  Stale,
  Expired
}

export namespace enumBacAccountStatus {
  export function values() {
    return Object.keys(enumBacAccountStatus).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
